/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        (function ($, document) {

          // Set focus on popup open (this popup only)
          

        // Customize these variables.
        // ----------------------------------
        var popups = [11641, 11645], // Comma separated popup IDs.
            cookie_name = 'pum-split-test', // Cookie name for the test only.
            cookie_time = '1 month', // Cookie timer.
            // ------------------------------
            // End Customizations.
            chosen_popup = false; // Empty placeholder.

        function random_popup() {
            return popups[Math.floor(Math.random() * popups.length)];
        }

        function get_chosen_popup() {
            var popup,
                cookie;

            if ($.pm_cookie === undefined) {
                return 0;
            }

            cookie = parseInt($.pm_cookie(cookie_name)) || false;

            // If the cookie contains a value use it.
            if (cookie > 0 && popups.indexOf(cookie) !== -1) {
                popup = cookie;
            } else if (!cookie) {
                popup = random_popup();
                $.pm_cookie(cookie_name, popup, cookie_time, '/');
            }

            return popup;
        }

        // Prevent non chosen popups from opening.
        $(document).on('pumBeforeOpen', '.pum', function () {
            var $this = $(this),
                ID = $this.popmake('getSettings').id;

            if (!chosen_popup) {
                chosen_popup = get_chosen_popup();
            }
          console.log('popups', popups);
          console.log('ID', ID);
          
            if (popups.indexOf(ID) >= 0 && ID !== chosen_popup) {
                $this.addClass('preventOpen');
            } else {
                $this.removeClass('preventOpen');
            }
        });
        $(document).on('pumBeforeOpen',function() {
          console.log("HI!!!"); 
          setTimeout(function() {
            PUM.open(14808);
            console.log("popup detected");
            $('#pum-14808 .pum-close').trigger('focus');
          }, 800);
        });
  
    }(jQuery, document));

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
